import * as requestFromServer from "./statesCrud";
import {statesSlice, callTypes} from "./statesSlice";

const {actions} = statesSlice;

export const fetchStates = queryParams => dispatch => {
  dispatch(actions.startCall({ callType: callTypes.list }));
  if (!queryParams.filter) { queryParams.filter = {}; }
  // check for approval status and update queryParams filter 
  const status = window.location.pathname.split("/")[2]
  if(status==="approved") { queryParams.filter.approval_status=0; }
  if(status==="pending")  { queryParams.filter.approval_status=1; }
  if(status==="rejected") { queryParams.filter.approval_status=2; }
  //For all records
  if(!status)             {queryParams.filter.approval_status=-1;}

  return requestFromServer
    .findStates(queryParams)
    .then(response => {
		const { totalCount, entities } = response.data
		dispatch(actions.statesFetched({totalCount, entities}));
    })
    .catch(error => {
      error.clientMessage = "Can't find states";
      dispatch(actions.catchError({ error, callType: callTypes.list }));
    });
}; 

export const fetchState = id => dispatch => {
  if (!id) {
    return dispatch(actions.stateFetched({ stateForEdit: undefined }));
  }

  dispatch(actions.startCall({ callType: callTypes.action }));
  return requestFromServer
    .getStateById(id)
    .then(response => {
      const state = response.data;
      dispatch(actions.stateFetched({ stateForEdit: state }));
    })
    .catch(error => {
      error.clientMessage = "Can't find state";
      dispatch(actions.catchError({ error, callType: callTypes.action }));
    });
};

export const deleteState = id => dispatch => {
  dispatch(actions.startCall({ callType: callTypes.action }));
  return requestFromServer
    .deleteState(id)
    .then(response => {
      dispatch(actions.stateDeleted({ id }));
    })
    .catch(error => {
      error.clientMessage = "Can't delete state";
      dispatch(actions.catchError({ error, callType: callTypes.action }));
    });
};

export const createState = stateForCreation => dispatch => {
  dispatch(actions.startCall({ callType: callTypes.action }));
   return requestFromServer
    .createState(stateForCreation)
    .then(response => {
      const { state } = response.data;
      dispatch(actions.stateCreated({ state }));
    })
    .catch(error => {
      error.clientMessage = "Can't create state";
      dispatch(actions.catchError({ error, callType: callTypes.action }));
    });
};

export const updateState = state => dispatch => {
  dispatch(actions.startCall({ callType: callTypes.action }));
  return requestFromServer
    .updateState(state)
    .then(() => {
      dispatch(actions.stateUpdated({ state }));
    })
    .catch(error => {
      error.clientMessage = "Can't update state";
      dispatch(actions.catchError({ error, callType: callTypes.action }));
    });
};

export const updateStatesStatus = (ids, status) => dispatch => {
  dispatch(actions.startCall({ callType: callTypes.action }));
  return requestFromServer
    .updateStatusForStates(ids, status)
    .then(() => {
      dispatch(actions.statesStatusUpdated({ ids, status }));
    })
    .catch(error => {
      error.clientMessage = "Can't update states status";
      dispatch(actions.catchError({ error, callType: callTypes.action }));
    });
};

export const deleteStates = ids => dispatch => {
  dispatch(actions.startCall({ callType: callTypes.action }));
  return requestFromServer
    .deleteStates(ids)
    .then(() => {
      dispatch(actions.statesDeleted({ ids }));
    })
    .catch(error => {
      error.clientMessage = "Can't delete states";
      dispatch(actions.catchError({ error, callType: callTypes.action }));
    });
};
